import {
  getObject,
  getBoolean,
} from "@surya-digital/leo-ts-types";
import { Code, CodeDTO } from "../types/code";

export interface GroupChildVisibilityDTO {
  childQuestionCode: CodeDTO;
  isViewVisible: boolean;
}

export class GroupChildVisibility {
  readonly isGroupChildVisibilityGroupChildVisibility: boolean = true;

  readonly childQuestionCode: Code;
  readonly isViewVisible: boolean;


  constructor(
  childQuestionCode: Code, 
  isViewVisible: boolean
  ) {
    this.childQuestionCode = childQuestionCode;
    this.isViewVisible = isViewVisible;
  }

  static fromDTO(dto: GroupChildVisibilityDTO): GroupChildVisibility {
    const childQuestionCode = Code.fromDTO(getObject(dto, "childQuestionCode", InvalidGroupChildVisibilityChildQuestionCodeError));
    const isViewVisible = getBoolean(dto, "isViewVisible", InvalidGroupChildVisibilityIsViewVisibleError);
    return new GroupChildVisibility(
      childQuestionCode,
      isViewVisible
    );
  }

  toDTO(): GroupChildVisibilityDTO {
    const dto: GroupChildVisibilityDTO = {
        childQuestionCode: this.childQuestionCode.toDTO(),
        isViewVisible: this.isViewVisible
    };
    return dto;
  }
  }

GroupChildVisibility.prototype.toString = function toString(): string {
  return `GroupChildVisibility(childQuestionCode='${this.childQuestionCode}',isViewVisible='${this.isViewVisible}')`;
};

export class InvalidGroupChildVisibilityError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildVisibilityError";
  }
}
export class InvalidGroupChildVisibilityChildQuestionCodeError extends InvalidGroupChildVisibilityError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildVisibilityChildQuestionCodeError";
  }
}

export class InvalidGroupChildVisibilityIsViewVisibleError extends InvalidGroupChildVisibilityError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildVisibilityIsViewVisibleError";
  }
}
